// extracted by mini-css-extract-plugin
module.exports = {"image-attachment__inner":"image-attachment__inner__yGCaU","image-container":"image-container__AvO57","hover-text":"hover-text__9itSX"};